<template>
  <div id="login">
    <div v-if="!forgotPassword" @keyup.enter="login">
      <div class="login-wrap responsive">
        <div class="login-html">
          <img src="../assets/img/iLogDPI.png" class="logo" />
          <div class="br-logo"></div>
          <div class="header-lnk">Welcome to iLog-DPI</div>
          <div class="hr-head"></div>
          <div class="login-form">
            <div class="sign-in-htm">
              <div class="group">
                <label for="username" class="label">Username:</label>
                <input
                  type="text"
                  class="input no-outline"
                  v-model="username"
                  placeholder="Username"
                  autofocus
                  required
                />
              </div>
              <div class="group">
                <label for="password" class="label">Password:</label>
                <input
                  type="password"
                  class="input no-outline"
                  data-type="password"
                  v-model="password"
                  placeholder="Password"
                  autofocus
                  required
                />
              </div>
              <br />
              <div class="group">
                <input
                  type="submit"
                  class="btn btn-outline-primary btn-lg btn-block"
                  style="border-radius: 25px;"
                  value="Sign In"
                  @click="login"
                />
              </div>
              <div class="hr-foot"></div>
              <div class="foot-lnk">
                <a href="#forgotpassword" @click="forgotPassword = true"
                  >Forgot Password?</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="forgotPassword">
      <div class="forgot-wrap responsive">
        <div class="forgot-html">
          <img src="../assets/img/iLogDPI.png" class="logo" />
          <div class="br-logo"></div>
          <div class="header-lnk">Reset Password</div>
          <div class="hr-head"></div>
          <div class="login-form">
            <div class="sign-in-htm">
              <div class="group">
                <label for="username" class="label">Username:</label>
                <input
                  type="text"
                  class="input no-outline"
                  v-model="username"
                  placeholder="Username (E-mail)"
                  autofocus
                  required
                />
              </div>
              <br />
              <div class="group">
                <input
                  type="submit"
                  class="btn btn-outline-primary btn-lg"
                  style="border-radius: 25px; width: 100%"
                  value="Reset Password"
                  @click="resetPassword"
                />
              </div>
              <div class="hr-foot"></div>
              <div class="foot-lnk">
                <a href="#forgotpassword" @click="forgotPassword = false"
                  >Back to Login</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="alert alert-danger alert-dismissible" v-if="loginfailed">
      <a href="#" class="close" data-dismiss="alert" aria-label="close"
        >&times;</a
      >
      Username or Password incorrect. Please try again or reset password.
    </div>
    <div class="alert alert-success" v-if="resetConfirm">
      <a href="#" class="close" data-dismiss="alert" aria-label="close"
        >&times;</a
      >
      The password reset link has been sent to the email {{ this.username }}.
      Please check your email inbox or junk mail.
    </div>
    <div class="alert alert-danger" v-if="resetfailed">
      <a href="#" class="close" data-dismiss="alert" aria-label="close"
        >&times;</a
      >
      Incorrect email.
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Login',
  beforeCreate() {
    sessionStorage.removeItem('user-token')
  },
  data() {
    return {
      username: '',
      password: '',
      timetoken: '60m',
      forgotPassword: false,
      loginfailed: false,
      resetConfirm: false,
      resetfailed: false,
    }
  },
  methods: {
    async login() {
      try {
        const response = await axios.post(
          //"https://dev.ilog.ai:8003/api/auth/login",
          'https://portal.ilog.ai:8001/api/auth/login',
          {
            username: this.username,
            password: this.password,
            timetoken: this.timetoken,
          }
        )
        sessionStorage.setItem('user-token', response.data.token)
        // this.$router.push({ name: 'home', params: { isExpired: response.data.isExpired } })
        response.data.role !== 'AIS_home'
          ? this.$router.push({
              name: 'home',
              params: { isExpired: response.data.isExpired },
            })
          : this.$router.push({
              name: 'home',
              params: { isExpired: response.data.isExpired },
            })
        // this.$router.push({ name: 'allhome', params: { isExpired: response.data.isExpired } })
        this.loginfailed = false
      } catch (error) {
        console.log(error)
        this.loginfailed = true
      }
    },
    async resetPassword() {
      try {
        let response = await axios.post(
          'https://portal.ilog.ai:8001/api/auth/forgot_password',
          {
            username: this.username,
          }
        )
        if (response.data.success) {
          this.resetConfirm = true
          this.forgotPassword = false
        }
      } catch (error) {
        console.error(error)
        this.resetfailed = true
      }
      this.forgotPassword = false
    },
  },
}
</script>

<style>
#login {
  background-image: url('../assets/img/bg-login.jpg');
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 100%;
  width: 100%;
  position: absolute;
  font: 600 16px/18px 'Open Sans', sans-serif;
}

.login-wrap {
  width: 480px;
  height: 540px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  box-shadow: 0 12px 15px 0 rgba(0, 0, 0, 0.24),
    0 17px 50px 0 rgba(0, 0, 0, 0.19);
}
.login-html {
  width: 100%;
  height: 100%;
  position: absolute;
  padding: 90px 70px 50px 70px;
  background: rgba(40, 57, 101, 0.9);
}
.forgot-wrap {
  width: 480px;
  height: 460px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  box-shadow: 0 12px 15px 0 rgba(0, 0, 0, 0.24),
    0 17px 50px 0 rgba(0, 0, 0, 0.19);
}
.forgot-html {
  width: 100%;
  height: 100%;
  position: absolute;
  padding: 90px 70px 50px 70px;
  background: rgba(40, 57, 101, 0.9);
}
.logo {
  width: 70%;
  height: 32%;
  position: absolute;
  top: 15%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.login-html .tab,
.login-form .group .label {
  text-transform: uppercase;
}
.login-form .group {
  margin-bottom: 15px;
}
.login-form .group .label,
.login-form .group .input {
  width: 100%;
  color: #fff;
  display: block;
}
.login-form .group .input {
  border: none;
  padding: 15px 20px;
  border-radius: 25px;
  background: rgba(255, 255, 255, 0.1);
}
.login-form .group input[data-type='password'] {
  -webkit-text-security: circle;
}
.login-form .group .label {
  color: #aaa;
  font-size: 12px;
}
.login-form .group .button {
  background: #1161ee;
}
.hr-head {
  height: 2px;
  margin: 20px 0 20px 0;
  background: rgba(255, 255, 255, 0.2);
}
.hr-foot {
  height: 2px;
  margin: 20px 0 28px 0;
  background: rgba(255, 255, 255, 0.2);
}
.header-lnk {
  color: #fff;
  font-family: 'Enriqueta', arial, serif;
  line-height: 1.25;
  margin: 0 0 10px;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
}
.foot-lnk {
  text-align: center;
}

.br-logo {
  margin: 30px 0 50px 0;
}

::-webkit-input-placeholder {
  text-align: center;
}

:-moz-placeholder {
  /* Firefox 18- */
  text-align: center;
}

::-moz-placeholder {
  /* Firefox 19+ */
  text-align: center;
}

:-ms-input-placeholder {
  text-align: center;
}

.no-outline:focus {
  outline: none;
}

/* .responsive {
  max-width: 100%;
  max-height: 100%;
} */
</style>
